import React, { useState } from 'react';

import { useDeleteModuleMutation } from 'src/redux/services/centralApi';
import { type Module } from 'src/interfaces/entities/module';
import { DeleteOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { Button, Flex, Modal } from 'antd';

export default function DeleteModule(
	{
		row,
	}: { row: Module }
) {
	const [ open, setOpen, ] = useState<boolean>(false);

	const [ deleteModule, deleteModuleResult, ] = useDeleteModuleMutation();

	return <>
		<Button
			type="text"
			danger
			icon={<DeleteOutlined />}
			onClick={() => setOpen(true)}
		/>
		<Modal
			centered
			title={'Excluir Módulo'}
			open={open}
			onCancel={() => {
				setOpen(false);
				toast.info('Operação cancelada!', { autoClose: 1000, });
			}}
			destroyOnHidden
			okText="Excluir"
			onOk={() => {
				deleteModule(row.module_id)
					.unwrap()
					.then(() => {
						toast.success('Módulo excluída com sucesso!', {
							autoClose: 1000,
						});
					})
					.catch((err) => {
						if (err?.status && err?.status === 500
							&& err?.data?.frontend_message) {
							toast.error(err?.data?.frontend_message, {
								autoClose: 1000,
							});
						}
					})
					.finally(() => {
						setOpen(false);
					});
			}}
			confirmLoading={deleteModuleResult.isLoading}
		>
			<Flex>
				{`Tem certeza que deseja deletar o módulo: ${row.name}`}
			</Flex>
		</Modal>
	</>;
}